import React, { Component } from 'react';
import AppCatalog from './AppCatalog';
import RenderApiNames from './RenderApiNames';
import {loginRedirect} from './../common/Util'
import {errorRedirect} from './../common/Util'

class AccountOverview extends Component {
  constructor(props) {
  super(props);
    this.state = {
        orgAlertMessage:''
    };
  }

  componentDidMount() {
      this.getOrgStatus();
  }

  getOrgStatus() {
      let myRequest = process.env.REACT_APP_HOST_API_URL + '/developer/mvc/userAlerts?filterByAlertType=ON_SCREEN';
      return fetch(myRequest, {
    	  headers: {
    		  'Accept': 'application/json',
    		  'Content-Type': 'application/json'
      		},
      	   method: 'GET'
      })
      .then((response) =>{
        if (!response.ok) {
          if(response.status === 401) {
            loginRedirect();
          } else {
            throw new Error("Unknown error occurred : " + response.statusText);
          }
        } else {
        	let contentType = response.headers.get("content-type");
            /*To check if the server is sending the empty resposne or not*/
        	if(contentType && contentType.includes("application/json")){
				return response.json();
			 } else {
				return false;
			}
        }
      })
      .then((data) => {
        let alertMsg = '';
        if(data && data.alert_name !== undefined) {
          if(data.alert_name === 'ORG_CANCEL') {
              alertMsg=[<i key="amk1" class="fas fa-exclamation-circle"></i>, " Your Developer Organization has been closed. If there are any questions; please contact ", <a key="amk2" href="/firstnet/support/submit-a-ticket">support</a>, "."];
          } else if(data.alert_name === 'ORG_HARD_SUSPEND') {
              alertMsg=[<i key="amk1" class="fas fa-exclamation-circle"></i>, " Access to FirstNet services is now restricted for apps associated with your organization. Please ", <a key="amk2" href="/firstnet/support/submit-a-ticket">contact us</a>, " right away to resolve the issues leading your suspension. Without further action your account may be closed."];
          } else if(data.alert_name === 'ORG_SOFT_SUSPEND') {
              alertMsg=[" Your organization has been suspended; leading to limited access to some APIs. Please ", <a key="amk2" href="/firstnet/support/submit-a-ticket">contact us</a>, " right away to prevent loss of all access to FirstNet services."];
          }
          this.setState({
            orgAlertMessage: alertMsg
          });
          return data;
        }

      })
      .catch(error => {
          console.log('error trying to  get users on screen alerts: \n', error);
          errorRedirect("request.processing.error");
      })
    }

  render() {
        const {currentUser} = this.props;

        return(
            <div className="container-fluid">
                <div className="row py-4">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 px-3 pb-4">
                                <h1 id="accountOverviewMainheading"><i className="fa fa-tachometer-alt"/> Account Overview</h1>
                            </div>
                        </div>
                        {this.state.orgAlertMessage && this.state.orgAlertMessage!==null &&
                        <div className="row">
                            <div id='orgAlertMessage' className="col-12 px-3 pb-4">{this.state.orgAlertMessage}</div>
                        </div>
                        }
                        <div className="row">
                            <div className="col-12 col-lg-6 manageSettings pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <h2 id="subHeadingSetting" className="card-title"><i className="fa fa-cog" /> Settings</h2>
                                        <div className="card-text-wrapper">
                                            <p id="subHeadingSettnigtext" className="card-text">View and manage organization details, subscription preference and review terms and conditions.</p>
                                        </div>
                                        <div className="link-wrapper">
                                            <a id="subHeadingSettingRedirect" href="/developer/mvc/manageMyAccount#/manageSettings" className="card-link">Manage settings &gt;</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6 communityProfileCard pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <h2 id="subHeadingCommunityProfile" className="card-title"><i className="fa fa-user" /> Community Profile</h2>
                                        <div className="card-text-wrapper">
                                            <p id="subHeadingCommunityProfiletext" className="card-text">Create and manage your profile for FirstNet Developer Community forums.</p>
                                        </div>
                                        <div className="link-wrapper">
                                            <a id="subHeadingCommunityProfileRedirect" href="/developer/mvc/user/communityProfile" className="card-link">Manage community profile &gt;</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6 myApis pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <h2 id="subHeadingMyAPIs" className="card-title"><i className="fa fa-code" /> My APIs</h2>
                                        <div className="card-text-wrapper">
                                            <RenderApiNames/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {(currentUser.opa && currentUser.organization !== null && currentUser.organization.memberType==="CORPORATE") &&
                            <div className="col-12 col-lg-6 OrgUserCard pb-4">
                                <div className="card h-100">
                                    <div className="card-body">
                                        <h2 id="subHeadingOrgUser" className="card-title"><i className="fa fa-users" /> Organization Users</h2>
                                        <div className="card-text-wrapper">
                                            <p id="subHeadingOrgUserText" className="card-text">View and manage your organization users.</p>
                                        </div>
                                        <div className="link-wrapper">
                                            <a id="subHeadingOrgUserRedirect" href="/developer/mvc/organization/manageUsers" className="card-link">Manage users &gt;</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        {(this.props.showAppcatalogInOverview &&
                            <div className="row myApps">
                                <div className="col-12">
                                    <div className="card h-100">
                                        <div className="card-body">
                                            <h2 id="subHeadingMyApps" className="card-title"><i className="fa fa-cloud-upload-alt" /> My Apps</h2>
                                            <div className="card-text-wrapper">
                                                <AppCatalog
                                                    catalog={this.props.catalog}
                                                    pageItems={this.props.pageItems}
                                                    itemsPerPage={this.props.itemsPerPage}
                                                    updateAppCatalog={this.props.updateAppCatalog}
                                                    updatePageInfo={this.props.updatePageInfo}
                                                    isPaginationRequired={false}
                                                />
                                            </div>
                                            <div className="link-wrapper">
                                                <a id="subHeadingMyAppsRedirect" href="#/myApps" className="card-link">View full list of your apps ></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default AccountOverview;



// WEBPACK FOOTER //
// ./src/manageMyAccount/AccountOverview.js